<app-data-table [columns]="columns" [data]="budgetsDataTable()" [filters]="filters" [totalRecords]="totalRecords()"
  [cardTemplate]="card" (add)="onAdd()" (edit)="onEdit($event)" (pageChange)="onPage($event)"
  (removeSelected)="onRemoveSelected($event)" [loading]="loading()" (search)="onSearch($event)" />

<ng-template #card let-budget>
  <div class="surface-card shadow-2 p-3 border-round h-full flex flex-column">
    <div class="flex align-items-center justify-content-between mb-3">
      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center bg-teal-100 text-teal-500 border-circle w-3rem h-3rem font-bold text-xl mr-2">
          <i class="pi pi-file-pdf"></i>
        </div>
        <div>
          <div class="font-bold text-900 border-round overflow-hidden text-overflow-ellipsis white-space-nowrap"
            style="max-width: 150px;">
            {{ budget.address || 'Sin dirección' }}
          </div>
          <div class="text-500 text-sm">{{ budget.createAt }}</div>
        </div>
      </div>
      <p-button icon="pi pi-ellipsis-v" [text]="true" [rounded]="true" severity="secondary"
        (onClick)="onEdit(budget)"></p-button>
    </div>

    <div class="flex flex-column gap-2 mb-3">
      <div class="text-700 line-height-3 overflow-hidden text-overflow-ellipsis"
        style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
        {{ budget.description || 'Sin descripción' }}
      </div>
    </div>

    <div class="flex flex-column gap-2 mt-auto">
      <div class="flex align-items-center justify-content-between">
        <span class="text-500 text-sm">Inicio: {{ budget.startAt || 'Pendiente' }}</span>
        <span class="p-tag p-tag-info p-tag-rounded">ID: {{ budget.id }}</span>
      </div>
    </div>

    <div class="flex gap-2 mt-3 pt-3 border-top-1 surface-border">
      <p-button label="Ver Detalles" icon="pi pi-eye" class="w-full" [outlined]="true" size="small"
        (onClick)="onEdit(budget)" />
    </div>
  </div>
</ng-template>

<app-add-budget [(visible)]="dialogVisible" (save)="onSave($event)" />